import { Button, fontSize, Modal, spacing } from '@retailer-platform/shared-components'
import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { useDomainMessages } from 'domains/partner-pick-devices/utils/domain/intl'

interface PartnerPickDeviceListConfirmDeactivateModalProps {
  onConfirm: () => void
  onClose: () => void
}

const wrapper = css({
  padding: `${spacing.X24}`,
})

const titleStyles = css({
  fontSize: fontSize.X18,
  marginBottom: spacing.X36,
  fontWeight: 'bold',
  textAlign: 'center',
})

const footerButtonStyles = css({
  display: 'flex',
  justifyContent: 'end',
  marginTop: spacing.X36,
})

export const PartnerPickDeviceListConfirmDeactivateModal: FunctionComponent<
  PartnerPickDeviceListConfirmDeactivateModalProps
> = ({ onConfirm, onClose }) => {
  const messages = useDomainMessages({
    title: 'partnerPickDevicesDomain.modal.deactivate.title',
    body: 'partnerPickDevicesDomain.modal.deactivate.body',
    confirm: 'partnerPickDevicesDomain.modal.deactivate.confirm',
    cancel: 'partnerPickDevicesDomain.modal.cancel',
  })

  return (
    <Modal isOpen onRequestClose={onClose}>
      <div
        css={wrapper}
        data-testid="partnerPickDeviceList-setStatus-deactivate-confirmation-modal"
      >
        <div css={titleStyles}>{messages.title}</div>

        <div>{messages.body}</div>

        <div css={footerButtonStyles}>
          <Button
            variant="secondary"
            onClick={onClose}
            data-testid="partnerPickDeviceList-setStatus-deactivate-confirmation-cancel"
          >
            {messages.cancel}
          </Button>
          <Button
            variant="detrimental"
            onClick={onConfirm}
            data-testid="partnerPickDeviceList-setStatus-deactivate-confirmation-confirm"
          >
            {messages.confirm}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
